import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CardModal, CardModalNotOkButton } from "../modal"
import { Word } from "../../model";
import { Names } from "../local-authority/local-authority-detail/add-word-modal"
import './style.scss'

export default class GlossaryModal
extends React.Component<GlossaryModalProps, State> {
	render() {
		const definitionLength = this.props.definitionLength
		const glossary         = this.props.glossary
		const isEditing        = this.props.isEditing
		const isSubmitting     = this.props.isSubmitting
		const maxLength        = 255
		const style            = this.props.isEditing ? { cursor: 'text' } : { cursor: 'pointer' }

		return <CardModal
		active={true}
		className="glossary"
		title="Glossaire"
		onClickCloseButton={this.props.onClickCloseButton}
		onClickFooterButton={this.props.onClickFooterButton}
		onSubmit={this.props.onSubmit}>
			{glossary && glossary.length
				? <dl>
					{glossary.map((row, i) => (
						<div className="columns">
							<div className="column is-11">
								<div>
									<dt key={i * 2}>
										{isEditing[i]
										? <div className="field">
											<div className={`control ${isSubmitting[i] ? "is-loading" : ""}`}>
												<input className={`input ${isEditing[i] ? "" : "is-static"}`} defaultValue={row.term} name={Names.TERM} style={style} type="text" readOnly={isEditing[i] ? false : true} disabled={isSubmitting[i] ? true : false}/>
												<input defaultValue={row.id.toString()} name={Names.ID} type="hidden" />
											</div>
										</div>
										: <span>{row.term}</span>}
									</dt>
									<dd key={i * 2 + 1}>
										{isEditing[i]
										?
										<div className="field">
											<div className={`control ${isSubmitting[i] ? "is-loading" : ""}`}>
												<textarea className={`textarea ${isEditing[i] ? "" : "is-static"} `} defaultValue={row.definition} maxLength={maxLength} name={Names.DEFINITION} onChange={this.props.onChangeDefinition} style={style} readOnly={isEditing[i] ? false : true } disabled={isSubmitting[i] ? true : false}/>
												<p className="help">{definitionLength ? definitionLength : row.definition.length} / {maxLength}</p>
											</div>
										</div>
										: <span>{row.definition}</span>}
									</dd>
								</div>
							</div>
							<div className="column is-1">
								<p className="buttons">
									<button className={`button ${isSubmitting[i] ? "is-loading" : ""}`} onClick={e => { this.props.onClickDeleteWord(i, row.id, row.term, e)}}>
										<span className="icon is-small">
											<FontAwesomeIcon icon="trash-alt"/>
										</span>
									</button>
									<button className={`button ${isSubmitting[i] ? "is-loading" : ""}`} type={isEditing[i] ? "submit" : "button"} onClick={e => !isEditing[i] && this.props.onClickEditingWord(i, e)}>
										<span className="icon is-small">
											<FontAwesomeIcon icon={isEditing[i] ? "check" : "pen-square"}/>
										</span>
									</button>
								</p>
							</div>
						</div>
					))}
				</dl>
				: <p>Aucun mot enregistré</p>
			}
		</CardModal>
	}
}

export interface GlossaryModalProps {
	definitionLength: number
	glossary: Word[]
	isEditing: boolean[]
	isSubmitting: boolean[]
	onChangeDefinition(e: React.SyntheticEvent<Element>): void
	onClickCloseButton(e: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onClickDeleteWord(index: number, id: number, term: string, e: React.SyntheticEvent<Element>): void
	onClickEditingWord(index: number, e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

interface State {
	isEditing: boolean[]
}


// WEBPACK FOOTER //
// ./src/component/glossary-modal/glossary-modal.tsx